import { createRequest } from "helpers/tools";

export const updateSource = async (id, data) => {
  return await createRequest({
    suffix: `sources/${id}`,
    method: "put",
    payload: data,
    handleError: false,
  });
};
